import {getRefundList} from "./refunds/mock";
import CancelablePromise from "mn-utils/CancelablePromise";
import {apiRequestAdmin} from "../ws";
import {ENDPOINT_ADMIN_KC_FEES_CONFIRM, ENDPOINT_ADMIN_KC_FEES_LIST} from "../../constants/api";

export function apiAdminKlubcoinFeesList(params) {
  const url = ENDPOINT_ADMIN_KC_FEES_LIST;
  params = params || {};
  params.offset = params.offset || 0;
  params.limit = params.limit || 10;

  if (process.env.MOCK) {
    const response = {
      list: getRefundList(params.limit),
      count: params.limit * 10,
    };
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequestAdmin(url, params);
}

export function apiAdminKlubcoinFeesComplete(params) {
  const url = ENDPOINT_ADMIN_KC_FEES_CONFIRM;
  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequestAdmin(url, params);
}
